import LocationForm from './LocationForm';

export default LocationForm;
export * from './LocationForm';
